<template>
  <el-dialog
    :visible.sync="dialogShow"
    width="487px"
    @close="close"
  >
    <div slot="title" class="title">身份选择</div>
    <!-- <div class="item" @click="showRealName(2)" v-if="(state === -1 && type === -1) || type === 2">
      <img :src="ossPath + '/pages/userCenter/ambassador.png'" alt="" />
      <div class="text">
        <div style="font-size: 22px;color: #333333">分销大使认证</div>
        <div style="font-size: 17px;color: #999999">邀请销售代理下单可享返佣</div>
      </div>
    </div> -->
    <template  v-if="!checked && checked !== 6">
      <div class="item" style="margin-top: 29px;" @click="showRealName(1)" v-if="(state === -1 && type === -1) || type === 1 || type === 7">
        <img :src="ossPath + '/pages/userCenter/agent.png'" alt="" />
        <div class="text">
          <div style="font-size: 22px;color: #333333">销售代理认证</div>
          <div style="font-size: 17px;color: #999999">可享一键全球到门最低价下单</div>
        </div>
      </div>
  <!--    <div class="item" style="margin-top: 29px;" @click="showRealName(3)" v-if="(state === -1 && type === -1) || type === 3">-->
  <!--      <img :src="ossPath + '/pages/userCenter/agent.png'" alt="" />-->
  <!--      <div class="text">-->
  <!--        <div style="font-size: 22px;color: #333333">省代认证</div>-->
  <!--        <div style="font-size: 17px;color: #999999">省级运营中心 享受省级区域保护扶持</div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div class="item" style="margin-top: 29px;" @click="showRealName(4)" v-if="(state === -1 && type === -1) || type === 4">-->
  <!--      <img :src="ossPath + '/pages/userCenter/agent.png'" alt="" />-->
  <!--      <div class="text">-->
  <!--        <div style="font-size: 22px;color: #333333">市代/产业带加盟商入驻</div>-->
  <!--        <div style="font-size: 17px;color: #999999">自带仓库 享受区域保护和扶持</div>-->
  <!--      </div>-->
  <!--    </div>-->
      <!--<div class="item" style="margin-top: 29px;" @click="showRealName(6)" v-if="(state === -1 && type === -1) || type === 6 || type === 7">
        <img :src="ossPath + '/pages/userCenter/agent.png'" alt="" />
        <div class="text">
          <div style="font-size: 22px;color: #333333">城市合伙人</div>
          <div style="font-size: 17px;color: #999999">一键全球 本市直拼  共赢财富</div>
        </div>
      </div>-->
    </template>
    <template v-else-if="checked === 6">
      <div class="partner-type-select">
        <el-button
          type="primary"
          :plain="checked !== item.value"
          class="partner-type-item"
          v-for="(item,index) in partnerTypeTabs"
          :key="index"
          @click="changePartnerType(item,index)"
        >
          <div class="label">{{item.label}}</div>
          <div class="description">{{item.description}}</div>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "real-name-type-select",
  props: {
    show: Boolean,
    // 类型 1：销售代理认证 2：分销大使认证，3：省代 4：产业带加盟商
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      dialogShow: this.show,
      checked: null,
      partnerTypeTabs:[
        {label:"公司申请",description:"需上传营业执照",value:1,},
        {label:"个人申请",description:"需上传个人身份证与从业简历",value:2,},
      ],
    }
  },
  computed: {
    state() {
      return this.$store.state.Authorization.authenticationInfoDTO.state
    }
  },
  watch: {
    show(val) {
      this.dialogShow = val
    }
  },
  methods: {
    showRealName(type=1) {
      if (type === 6) {
        // this.checked = type
        // 1-公司 2-个人
        this.$emit('toRealName', type, 2)
      } else {
        this.$emit('toRealName', type)
      }
    },
    changePartnerType(aType) {
      this.$emit('toRealName', 6, aType.value)
      this.checked = null
    },
    close() {
      this.$emit('close')
      this.checked = null
    }
  }
}
</script>

<style scoped lang="less">
.el-dialog {
  border-radius: 10px !important;
}

/deep/ .el-dialog__body {
  padding: 1px 15px 57px !important;
}
.title {
  color: #333333;
  font-size: 26px;
  font-weight: 500;
}
.item {
  width: 455px;
  height: 104px;
  background: #FFFFFF;
  box-shadow: 0 0 13px 0 rgba(0,0,0,0.06);
  border-radius: 20px;
  padding: 27px 33px 20px 33px;
  display: flex;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }

  img {
    width: 57px;
    height: 57px;
    margin-right: 25px;
  }
  .text {
    font-weight: 500;
  }
}
/* 合伙人认证类型选择 */
.partner-type-select{
  padding: 60px 0;
  .partner-type-item{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 450px;
    height: 84px;
    border-radius: 6px;
    margin: 20px auto;
    &.is-plain{
      &:not(:hover){
        background-color: white;
      }
    }
    .label{
      font-size: 18px;
      font-weight: bold;
    }
    .description{
      font-size: 16px;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/components/real-name-type-select.vue